<template>
  <div class="embed-responsive embed-responsive-1by1" v-if="imageUrl">
    <div class="event-image embed-responsive-item rounded-circle border border-white" :style="{ 'background-image': `url(${imageUrl})` }"></div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "event-image",
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        imageUrl: null
      }
    },
    async mounted() {
      let storageRef = await firebase.storage()
      let imageRef = await storageRef.ref(`images/${this.event.image}`)
      this.imageUrl = await imageRef.getDownloadURL()
    }
  }
</script>

<style lang="scss" scoped>
  .event-image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    left: 0;
    top: 0;
    border-width: 5px !important;
  }
</style>